<script lang="ts">
    import {
        END_CARD_ADRESS,
        END_CARD_PART_FOUR,
        END_CARD_PART_ONE,
        END_CARD_PART_THREE,
        END_CARD_PART_TWO,
        END_CARD_TEXT_THREE
    } from '../constants/imgList';

    import webp from '@/actions/webp';

    const stepParts = [
        {
            bg: END_CARD_PART_ONE,
            text: 'Completa tus datos'
        },
        {
            bg: END_CARD_PART_TWO,
            text: 'Descarga la app de DiDi Finanzas'
        },
        {
            bg: END_CARD_PART_THREE,
            text: 'Recibe tus cupones de 3MSI al ser aprobada'
        },
        {
            bg: END_CARD_PART_FOUR,
            text: 'Continúa con tu solicitud'
        }
    ];

</script>

<div class="card-end-step">
    <div
        class="step-title"
        use:webp={END_CARD_TEXT_THREE}
        role="img"
        aria-label="Pasos para solicitar"
    ></div>
    <div class="step-grid">
        {#each stepParts as step, index (index)}
            <div class="step-item">
                <div class="step-part-bg" use:webp={step.bg}></div>
                <p class="step-part-text">{step.text}</p>
            </div>
        {/each}
    </div>
    <img
        class="step-address"
        src={END_CARD_ADRESS}
        alt=""
        use:webp={END_CARD_ADRESS}
    />
</div>

<style lang="scss">
    .card-end-step {
        position: relative;
        z-index: 1;
        width: 100%;
        box-sizing: border-box;
        /* 距上方 benefit 模块 40px */
        margin-top: 0.4rem;
    }

    .step-title {
        width: 100%;
        height: 1.2rem;
        margin: 0 auto;
        /* 距下方步骤卡片 14px */
        margin-bottom: 0.14rem;
        background-repeat: no-repeat;
        background-size: contain;
        background-position: center;
    }

    .step-grid {
        width: 6.86rem;
        margin: 0 auto;
        display: grid;
        grid-template-columns: repeat(2, 3.33rem);
        gap: 0.2rem;
        box-sizing: border-box;
    }

    .step-item {
        position: relative;
        width: 3.33rem;
        height: 2.04rem;
        overflow: hidden;
    }

    .step-part-bg {
        position: absolute;
        inset: 0;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        background-position: center;
        pointer-events: none;
    }

    .step-part-text {
        position: absolute;
        /* 设计稿距卡片顶部 100px、左侧 28px */
        top: 1rem;
        left: 0.28rem;
        right: 0.16rem;
        margin: 0;
        font-family: DiDiSans-Pro-Regular;
        font-size: 0.24rem;
        font-style: normal;
        font-weight: 400;
        line-height: 0.32rem;
        letter-spacing: 0;
        color: #ffffff;
    }

    @supports (color: color(display-p3 1 1 1)) {
        .step-part-text {
            color: color(display-p3 1 1 1);
        }
    }

    .step-address {
        position: relative;
        z-index: 2;
        width: 7.5rem;
        margin-top: 0.55rem;
        margin-left: -0.32rem;
        min-height: 2.5rem;
        height: auto;
        display: block;
        object-fit: cover;
    }
</style>
